import
  React
from 'react';

import
  styled
from 'styled-components';

import {
  PropTypes
} from 'prop-types';

import {
  Base,
  ColorSvg,
  HContainer,
  HSeparator,
  Spinner,
  VContainer,
  VFillContainerVH
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../constants';

const ArrowContainer = styled(Base)`
  display: flex;
  align-items: center;
  justify-content: center;

  ${props => props.transition && `transition: ${props.transition};`}
  ${props => props.rotate && `transform: rotate(${props.rotate}deg);`}
  ${props => props.rotateX && `transform: rotateX(${props.rotateX}deg);`}
`;

export const Arrow = props => (

  <ArrowContainer
    rotate={props.rotate}
    padding={props.padding}
    margin={props.margin}
    transition={props.transition}
    rotateX={props.rotateX}>

    <ColorSvg
      id={props.id}
      automationId={props.automationId}
      src={Icons.Chevron}
      height={props.size}
      width={props.size}
      minHeight={props.minHeight}
      minWidth={props.minWidth}
      maxHeight={props.maxHeight}
      maxWidth={props.maxWidth}
      onClick={props.onClick}
      color={props.color}
      hoverColor={props.hoverColor}/>

  </ArrowContainer>
);

Arrow.propTypes = {
  ...Base.propTypes,
  id: PropTypes.string,
  rotate: PropTypes.string,
  size: PropTypes.string,
  onClick: PropTypes.func,
  rotateX: PropTypes.string,
  transition: PropTypes.string
};

Arrow.defaultProps = {
  ...Base.defaultProps,
  id: 'unknown-arrow',
  rotate: '-90',
  size: '19px',
  padding: '0',
  onClick: null,
  rotateX: null,
  transition: null,
  color: null
};

export const Accordion = props => {

  const myRef = React.useRef(null);

  React.useEffect(() => {

    if (props.isOpen) {

      myRef?.current?.scrollIntoView();

      let scrolledY = window.scrollY;

      if (scrolledY) {
        window.scroll(0, scrolledY - 80);
      }
    }

  }, [ props.isOpen ]);

  return (

    <Base
      ref={myRef}>

      <HContainer
        onClick={props.onAccordionClick}
        padding={props.padding}>

        {props.header}

        <Base
          margin='0 0 0 auto'>

          <Arrow
            id={`${props.id}-arrow`}
            transition={props.arrowTransition}
            rotate={(props.isOpen && '270') || '90'}
            size={props.arrowSize}
            color={props.arrowColor}/>
        </Base>
      </HContainer>

      <HSeparator/>

      { props.isOpen &&

        <VContainer>

          { props.content ||

            <VFillContainerVH
              padding={props.spinnerContainerPadding || '9vmin'}>

              <Spinner
                size={props.spinnerSize}/>

            </VFillContainerVH>
          }

          <HSeparator />

        </VContainer>
      }
    </Base>
  );
};

Accordion.propTypes = {
  header: PropTypes.element,
  content: PropTypes.element,
  isOpen: PropTypes.bool,
  arrowTransition: PropTypes.string,
  arrowSize: PropTypes.string,
  arrowColor: PropTypes.string,
  spinnerSize: PropTypes.string,
  padding: PropTypes.string
};

Accordion.defaultProps = {
  header: null,
  content: null,
  isOpen: false,
  arrowTransition: 'transform 0.3s linear',
  arrowSize: '19px',
  arrowColor: CustomColors.Grey8,
  spinnerSize: '5vh',
  padding: '18px 18px 12px 16px'
};
